/**
 * JINSA – Enhanced Search Panel
 * Shows popular searches + category grid when input is focused and empty.
 * Hides automatically when the user starts typing (native predictive-search takes over).
 */
(function () {
  'use strict';

  // ── Static data ──────────────────────────────────────────────────────────
  const POPULAR_SEARCHES = [
    'Manómetro', 'Temporizador', 'Sensor Pepperl+Fuchs',
    'Relé de potencia', 'Autonics', 'Winters'
  ];

  // Read real product counts from the Liquid-rendered JSON tag
  function loadCategories() {
    try {
      const el = document.getElementById('jinsa-collection-data');
      if (el) return JSON.parse(el.textContent);
    } catch (e) { /* fall through */ }
    return [];
  }
  const CATEGORIES = loadCategories();

  const TREND_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>`;

  // ── Build panel HTML ──────────────────────────────────────────────────────
  function buildPanel() {
    const chipsHtml = POPULAR_SEARCHES.map(s =>
      `<a class="jinsa-search-chip" href="/search?q=${encodeURIComponent(s)}">${TREND_SVG}${s}</a>`
    ).join('');

    const catsHtml = CATEGORIES.map(c => `
      <a class="jinsa-search-cat-item" href="/collections/${c.handle}">
        <span class="jinsa-search-cat-badge">${c.code}</span>
        <span>
          <div class="jinsa-search-cat-name">${c.name}</div>
          <div class="jinsa-search-cat-count">${c.count} productos</div>
        </span>
      </a>`
    ).join('');

    return `
      <div class="jinsa-search-panel-section">
        <div class="jinsa-search-panel-title">Búsquedas populares</div>
        <div class="jinsa-search-chips">${chipsHtml}</div>
      </div>
      <div class="jinsa-search-panel-divider"></div>
      <div class="jinsa-search-panel-section">
        <div class="jinsa-search-panel-title">Explorar categorías</div>
        <div class="jinsa-search-categories">${catsHtml}</div>
      </div>`;
  }

  // ── Attach to a single search field container ─────────────────────────────
  function attachPanel(fieldEl) {
    if (fieldEl.dataset.jinsaEnhanced) return;
    fieldEl.dataset.jinsaEnhanced = '1';

    const panel = document.createElement('div');
    panel.className = 'jinsa-search-panel';
    panel.setAttribute('role', 'listbox');
    panel.innerHTML = buildPanel();

    // Insert inside .field so it inherits position:relative context
    fieldEl.style.position = 'relative';
    fieldEl.appendChild(panel);

    const input = fieldEl.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    let focusTimeout;

    function show() {
      if ((input.value || '').trim() === '') {
        panel.classList.add('open');
      }
    }

    function hide() {
      clearTimeout(focusTimeout);
      focusTimeout = setTimeout(() => panel.classList.remove('open'), 180);
    }

    input.addEventListener('focus', show);
    input.addEventListener('input', () => {
      if ((input.value || '').trim() !== '') {
        panel.classList.remove('open');
      } else {
        show();
      }
    });
    input.addEventListener('blur', hide);

    // Keep panel open when clicking inside it
    panel.addEventListener('mousedown', (e) => e.preventDefault());
    panel.addEventListener('click', () => panel.classList.remove('open'));
  }

  // ── Init: find all header search field wrappers ───────────────────────────
  function init() {
    const fields = document.querySelectorAll('.header__search .field');
    fields.forEach(attachPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();